const isBrowser = typeof document !== "undefined";
export {
  isBrowser
};
//# sourceMappingURL=is-browser.js.map
